import { CARD_TYPE } from '../constants/constants'

export const getCardTypeContent = (cardTypeId, contentKeyPrefix, content) => {
  const contentKeySuffix = Object.values(CARD_TYPE).find(({ id }) => cardTypeId === id)?.contentKey
  return content?.[`${contentKeyPrefix}_${contentKeySuffix}`] ?? `${contentKeyPrefix}_${contentKeySuffix}`
}
